const AccountInfo = {};

AccountInfo.CLASS = {
  TITAN: {
    id: 1,
    title: 'Titan',
  },
  HUNTER: {
    id: 2,
    title: 'Hunter',
  },
  WARLOCK: {
    id: 3,
    title: 'Warlock',
  },
};

AccountInfo.CLASS.LIST = [
  AccountInfo.CLASS.TITAN,
  AccountInfo.CLASS.HUNTER,
  AccountInfo.CLASS.WARLOCK,
];

AccountInfo.CLASS.ID_TO_DATA = {
  [AccountInfo.CLASS.TITAN.id]: AccountInfo.CLASS.TITAN,
  [AccountInfo.CLASS.HUNTER.id]: AccountInfo.CLASS.HUNTER,
  [AccountInfo.CLASS.WARLOCK.id]: AccountInfo.CLASS.WARLOCK,
};

AccountInfo.CROSS_SAVE = {
  NA: {
    id: 1,
    title: 'Not active',
  },
  PC_XBOX: {
    id: 2,
    title: 'PC & XBox',
  },
  PC_PS4: {
    id: 3,
    title: 'PC & PS4',
  },
  XBOX_PS4: {
    id: 4,
    title: 'XBox & PS4',
  },
  PC_PS4_XBOX: {
    id: 5,
    title: 'PC & PS4 & XBox',
  },
};

AccountInfo.CROSS_SAVE.LIST = [
  AccountInfo.CROSS_SAVE.NA,
  AccountInfo.CROSS_SAVE.PC_XBOX,
  AccountInfo.CROSS_SAVE.PC_PS4,
  AccountInfo.CROSS_SAVE.XBOX_PS4,
  AccountInfo.CROSS_SAVE.PC_PS4_XBOX,
];

AccountInfo.CROSS_SAVE.ID_TO_DATA = {
  [AccountInfo.CROSS_SAVE.NA.id]: AccountInfo.CROSS_SAVE.NA,
  [AccountInfo.CROSS_SAVE.PC_XBOX.id]: AccountInfo.CROSS_SAVE.PC_XBOX,
  [AccountInfo.CROSS_SAVE.PC_PS4.id]: AccountInfo.CROSS_SAVE.PC_PS4,
  [AccountInfo.CROSS_SAVE.XBOX_PS4.id]: AccountInfo.CROSS_SAVE.XBOX_PS4,
  [AccountInfo.CROSS_SAVE.PC_PS4_XBOX.id]: AccountInfo.CROSS_SAVE.PC_PS4_XBOX,
};

// eslint-disable-next-line import/prefer-default-export
export { AccountInfo };
